import React from 'react';
import classNames from 'classnames';
import AntdCollapsePanel, { CollapsePanelProps, CollapsibleType } from 'antd/lib/collapse/CollapsePanel';
import { cloneElement } from 'antd/lib/_util/reactNode';
import Collapse from './Collapse';
import { ConfigContext } from '../config-provider';
const CollapsePanel = (props) => {
    const { getPrefixCls } = React.useContext(ConfigContext);
    const { className, children, ...otherProps } = props;
    let hasNestedCollapse = false;
    const renderedChildren = React.Children.map(children, (child) => {
        if (React.isValidElement(child) && child.type === Collapse) {
            const prefixCls = getPrefixCls('collapse', child.props.prefixCls);
            const mergedClassNames = classNames(child.props.className, `${prefixCls}-nested`);
            hasNestedCollapse = true;
            return cloneElement(child, child.props && { className: mergedClassNames });
        }
        else {
            return child;
        }
    });
    const collapsePanelClassName = classNames({
        [`${props.prefixCls}-item-with-nested-collapse`]: hasNestedCollapse
    }, className);
    return (React.createElement(AntdCollapsePanel, { className: collapsePanelClassName, ...otherProps }, renderedChildren));
};
// export default withConfigProvider(CollapsePanel);
export default CollapsePanel;
